import React, { useEffect, useRef, useState } from "react";
import withRouter from "../Common/withRouter";

const RightSidebar = (props) => {
  const leftSidebarDark = useRef(null);

  const [show] = useState(false);

  useEffect(() => {
    if (
      show &&
      leftSidebarDark.current &&
      document.getElementById("sidebar-color-light")
    ) {
      leftSidebarDark.current.checked = false;
      document.getElementById("sidebar-color-light").checked = false;
    }
  });

  window.onscroll = function () {
    scrollFunction();
  };

  const scrollFunction = () => {
    const element = document.getElementById("back-to-top");
    if (element) {
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        element.style.display = "block";
      } else {
        element.style.display = "none";
      }
    }
  };

  const toTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  return (
    <React.Fragment>
      <button
        onClick={() => toTop()}
        className="btn btn-danger btn-icon"
        id="back-to-top"
      >
        <i className="ri-arrow-up-line"></i>
      </button>
    </React.Fragment>
  );
};

export default withRouter(RightSidebar);
